/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/Initialize.ts
 * @create:      2022-06-26 08:24:01.207
 * @modify:      2025-07-11 20:47:10.533
 * @version:     6.0.0
 * @times:       42
 * @lines:       83
 * @copyright:   Copyright © 2022-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { IAsyncDataAcquisition } from "./interface/IAsyncDataAcquisition";
import { ISyncDataAcquisition } from "./interface/ISyncDataAcquisition";
import { ToUTF8ByteArray } from "./string/ToUTF8ByteArray";
import { TAsyncHashInput, TSyncHashInput } from "./type/advanced";

/**
 * @since 4.5.0
 * @version 2025-05-19
 */
export function InitializeSyncDataAcquisition(value: TSyncHashInput): ISyncDataAcquisition {
    if (typeof value === "string") {
        value = ToUTF8ByteArray(value);
    }

    if (value instanceof Uint8Array) {
        value = Array.from(value);
    }

    if (Array.isArray(value)) {
        return {
            Acquire: (offset, length) => value.slice(offset, offset + length),
            TotalLengthInBytes: value.length,
        };
    }

    return value;
}

/**
 * @since 4.5.0
 * @version 2025-05-20
 */
export function InitializeAsyncDataAcquisition(value: TAsyncHashInput): IAsyncDataAcquisition {
    if (typeof value === "string") {
        value = ToUTF8ByteArray(value);
    }

    if (value instanceof Uint8Array) {
        value = Array.from(value);
    }

    if (Array.isArray(value)) {
        return {
            AcquireAsync: async (offset, length) => value.slice(offset, offset + length),
            TotalLengthInBytes: value.length,
        };
    }

    return value;
}
